import React from "react";
import QuestionMultiple from "./QuestionMultiple";
import QuestionProgressPictures from "./QuestionProgressPictures";
import QuestionScale from "./QuestionScale";
import QuestionShort from "./QuestionShort";
import SvgIcon from "../../../../parts/SvgIcon";
import QuestionOptions from "./QuestionCreateOptions";

const QuestionDisplay = ({
  title,
  type,
  body,
  id,
  onEdit,
  onDelete,
  disableEdit,
  templateDisplay = false,
}) => {
  const questionType = getQuestionType(type, body);

  return (
    <div className={"questionnaire-question"}>
      <div className="question-header">
        <h4>{String(title)}</h4>
        {/* desktop view */}
        {!templateDisplay && !disableEdit && (
          <QuestionButtonsDisplay
            disableEdit={disableEdit}
            id={id}
            onEdit={onEdit}
            onDelete={onDelete}
            classNames="question-buttons force-mobile-hidden"
          />
        )}
      </div>
      <div className="question-body">{questionType}</div>
      {/* mobile view */}
      {!templateDisplay && !disableEdit && (
        <QuestionButtonsDisplay
          disableEdit={disableEdit}
          id={id}
          onEdit={onEdit}
          onDelete={onDelete}
          classNames="question-buttons force-only-show-mobile"
        />
      )}
    </div>
  );
};

const getQuestionType = (type, body) => {
  switch (type) {
    case "short":
    case "bodyweight":
    case "nutrition":
    case "steps":
    case "sleep":
    case "hrv":
      return <QuestionShort description={body.description} />;
    case "multiple":
    case "checkbox":
      return <QuestionMultiple type={body.type} options={body.options} />;
    case "progress":
      return <QuestionProgressPictures />;
    case "scale":
      return (
        <QuestionScale
          labelLeft={body.labelLeft}
          labelRight={body.labelRight}
        />
      );
    case "measurement":
      return <QuestionOptions options={body?.options} />;
    default:
      return <div>Error displaying the question</div>;
  }
};

const QuestionButtonsDisplay = ({
  disableEdit,
  id,
  onEdit,
  onDelete,
  classNames,
}) => {
  return (
    <div className={classNames}>
      <button
        data-button-type="secondary"
        data-icon-only
        sz="medium"
        onClick={() => {
          if (!disableEdit) {
            onEdit(id);
          }
        }}
      >
        <SvgIcon src="/img/new-icons/edit-pencil.svg" alt="edit" />
      </button>
      <button
        data-button-type="secondary"
        data-icon-only
        sz="medium"
        onClick={() => {
          if (!disableEdit) {
            onDelete(id);
          }
        }}
      >
        <SvgIcon
          src="/img/new-icons/red-trash.svg"
          alt="delete"
          noFilterOnLight={true}
        />
      </button>
    </div>
  );
};

export default QuestionDisplay;
